import { ComponentPropsWithoutRef, LegacyRef } from 'react';

export interface ButtonProps extends ComponentPropsWithoutRef<'button'> {
  visualType?: 'primary' | 'secondary' | 'secondary-blue-text' | 'danger' | 'no-bg';
  innerRef?: LegacyRef<HTMLButtonElement>;
}

export default function Button({ visualType = 'primary', className, type = 'button', innerRef, ...rest }: ButtonProps) {
  return <button className={`button button-${visualType} ${className}`} type={type} {...rest} ref={innerRef} />;
}
